export default __webpack_public_path__ + "static/media/bat-per-capita.8b75cd0b.svg";